const androidheader=()=>{
    return(
        <>
            <div className="container-fluid">
                <div className="container androidheaderpic">

                </div>

                <h1 className="display-1 mobileTextmobileheader" style={{position:'absolute', color:'#ffffff', marginLeft:'150px', marginTop:'-370px', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>MOBILE APP DEVELOPMENT</h1>

            </div>
        </>
    )
}

export default androidheader